/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { useDispatch } from 'react-redux';
import { MdVideoLabel } from 'react-icons/md';
import Switch from 'react-switch';
import { useHistory } from 'react-router-dom';
import PrimaryButton from './PrimaryButton';
import '../../assets/scss/Car.scss';
import DropdownMenu from '../DropdownMenu';
import Row from '../Grid/Row';
import Col from '../Grid/Col';
import { setCarActiveFlag } from '../../actions/carActions';
import { SHARE_CAR_ROUTE } from '../router/routes';

function Car({ data }) {
  const dispatch = useDispatch();
  const history = useHistory()

  function openShareCarModal() {
    history.push(SHARE_CAR_ROUTE.replace(':carId', data.carId), data)
  }

  const items = [
    {
      text: 'Sdílet auto',
      action: openShareCarModal
    }
  ];

  return (
    <div className="car box box--secondary">
      <div className="box__header">
        <span className="box__header-title">
          <PrimaryButton carId={data.carId} />
          {data.brand}
        </span>
        <div className="box__header-right">
          <DropdownMenu items={items} />
        </div>
      </div>
      <div className="box__body">
        <Row>
          <Col>
            <MdVideoLabel className="icon" />
            {data.plateNo}
          </Col>
          <Col>
            <span style={{ float: 'left', marginRight: 10 }}>Aktivní</span>
            <Switch
              onChange={(value) =>
                dispatch(setCarActiveFlag(data.carId, value))}
              checked={data.active}
              height={20}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Car;
